import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import ModalOverlay from '../../../components/ui/ModalOverlay/ModalOverlay';
import s from '../CaseFilePage.module.css';

interface CompleteTaskModalProps {
  completeTaskType: string;
  setCompleteTaskType: (v: string) => void;
  handleOpenSelectedTask: () => void;
  onClose: () => void;
}

export default function CompleteTaskModal({
  completeTaskType,
  setCompleteTaskType,
  handleOpenSelectedTask,
  onClose,
}: CompleteTaskModalProps) {
  return (
    <ModalOverlay onClose={onClose} title="Complete Task">
      <div className={s.modalForm}>
        <div className={s.formGroup}>
          <label>Select Task Type</label>
          <select value={completeTaskType} onChange={(e) => setCompleteTaskType(e.target.value)}>
            <option value="">Choose…</option>
            <option value="risk-assessment">Risk Assessment</option>
            <option value="pre-issue-checklist">Pre-Issue Checklist</option>
          </select>
        </div>
        <div className={s.modalActions}>
          <button className={s.btnSecondary} onClick={onClose}>
            Cancel
          </button>
          <button
            className={s.btnPrimary}
            onClick={handleOpenSelectedTask}
            disabled={!completeTaskType}
          >
            <FontAwesomeIcon icon={faCheck} /> Open
          </button>
        </div>
      </div>
    </ModalOverlay>
  );
}
